//  2. Файл: src/utils/helpers.js
//  Вспомогательные функции (хуки и расчеты).


import { useState, useEffect } from "react";

export const calculateTotals = (banquet) => {
  const items = banquet.items || [];
  const subtotal = items.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );
  const serviceAmount = subtotal * ((banquet.servicePercent || 0) / 100);
  const totalRevenue = subtotal + serviceAmount;
  return { subtotal, serviceAmount, totalRevenue };
};

export const capitalize = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return isMobile;
};